import { nanoid } from "@reduxjs/toolkit"
import TipoArticuloStatusMessage from "common/components/StatusMessage/TipoArticuloStatusMessage"
import createImgURI from "common/utils/createImgURI"
import { formatCurrency } from "common/utils/currency"
import { categoriasSelector } from "features/Inventario/redux/selectors/categoriasSelectors"
import { getAllCategoriasPadre } from "features/Inventario/redux/slices/categoriasSlice"
import ArticuloService from "features/Inventario/services/ArticuloService"
import { useDispatch } from "hooks/useDispatch"
import { useSelector } from "hooks/useSelector"
import { Skeleton } from "primereact/skeleton"
import { useCallback, useEffect, useRef, useState } from "react"
import { CameraOff } from "react-feather"
import ArticulosFilter from "../ArticulosFilter/ArticulosFilter"
import "./styles.scss"

const ArticuloSkeleton = () => (
  <div className='articulo'>
    <div className='articulo__image'>
      <Skeleton
        width='15em'
        height='8em'
      />
    </div>

    <div className='articulo__referencia'>
      <Skeleton
        width='8em'
        height='1em'
      />
    </div>

    <div className='articulo__concepto'>
      <Skeleton
        width='50%'
        height='1em'
      />
    </div>

    <div className='articulo__footer'>
      <Skeleton
        width='5em'
        height='1em'
      />

      <span className='articulo__precioVenta'>
        <Skeleton
          width='5em'
          height='1em'
        />
      </span>
    </div>
  </div>
)

export const ArticulosSkeletons = ({ times }: $TSMigrationFixMe) => {
  return [...new Array(times).keys()].map(() => (
    <ArticuloSkeleton key={nanoid()} />
  ))
}

const Articulo = ({
  concepto,
  thumbnailBase64,
  thumbnailMediaType,
  numeroReferencia,
  tipoArticulo,
  precioVenta,
}: $TSMigrationFixMe) => (
  <div className='articulo'>
    <div className='articulo__image'>
      {thumbnailBase64 ? (
        <img
          src={createImgURI(thumbnailBase64, thumbnailMediaType)}
          alt='imagen del artículo'
        />
      ) : (
        <CameraOff />
      )}
    </div>

    <div className='articulo__referencia'>
      <span>#{numeroReferencia}</span>
    </div>

    <div className='articulo__concepto'>
      <span>{concepto}</span>
    </div>

    <div className='articulo__footer'>
      <TipoArticuloStatusMessage
        outlined={false}
        tipoArticulo={tipoArticulo}
      />

      <span className='articulo__precioVenta'>
        {formatCurrency(precioVenta)}
      </span>
    </div>
  </div>
)

const ViewArticulos = () => {
  const lastArticuloRef = useRef()
  const [articulos, setArticulos] = useState([])
  const [loadingArticulos, setLoadingArticulos] = useState(true)
  const [loadingMoreArticulos, setLoadingMoreArticulos] = useState(false)
  const { categoriasPadre } = useSelector(categoriasSelector)

  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(getAllCategoriasPadre())
  }, [dispatch])

  const handledOnLoadArticulos = useCallback(
    async (filters: $TSMigrationFixMe) => {
      setLoadingArticulos(!filters?.loadingMoreArticulos)
      setLoadingMoreArticulos(filters?.loadingMoreArticulos)

      try {
        const { data } = await ArticuloService.getByFiltersConcepto(filters)
        if (filters?.loadingMoreArticulos) {
          // @ts-expect-error TS(2345): Argument of type '(prevArticulos: never[]) => any[...
          setArticulos((prevArticulos) => [...prevArticulos, ...data.items])
        } else {
          setArticulos(data.items)
        }
      } finally {
        setLoadingArticulos(false)
        setLoadingMoreArticulos(false)
      }
    },
    []
  )

  const noArticulos =
    !loadingMoreArticulos && !loadingArticulos && !articulos.length

  return (
    <>
      <ArticulosFilter
        // @ts-expect-error TS(2322): Type '{ categorias: $TSFixMe; ref: MutableRefObject<und...
        categorias={categoriasPadre}
        ref={lastArticuloRef}
        onFilter={handledOnLoadArticulos}
      />
      {/* TODO: i18n */}
      {noArticulos && <h5 className='mt-5'>No se han encontrado artículos</h5>}

      <div className='articulos'>
        {loadingArticulos ? (
          <ArticulosSkeletons times={10} />
        ) : (
          articulos.map((articulo) => (
            <Articulo
              // @ts-expect-error TS(2339): Property 'id' does not exist on type 'never'.
              key={articulo.id}
              // @ts-expect-error TS(2698): Spread types may only be created from object types...
              {...articulo}
            />
          ))
        )}

        {/* @ts-expect-error TS(2322): Type 'MutableRefObject<undefined>' is not assignab... */}
        {!noArticulos && <div ref={lastArticuloRef} />}
        {loadingMoreArticulos && <ArticulosSkeletons times={10} />}
      </div>
    </>
  )
}

export default ViewArticulos
